'use client'

import { SingleProductImage } from 'product-card/components/shared/ProductImage/SingleProductImage/SingleProductImage'
import { useProductCard } from 'product-card/hooks/useProductCard'
import { useProductCardImpression } from 'product-card/hooks/useProductCardImpression/useProductCardImpression'
import { useSortedProductImages } from 'product-card/hooks/useSortedProductImages/useSortedProductImages'
import type { ProductCardBaseProps } from 'product-card/types'
import { useRef } from 'react'

export const OverviewProductCard = ({ className }: ProductCardBaseProps) => {
	const productCardRef = useRef<HTMLDivElement | null>(null)

	const { dataTestId } = useProductCard()

	useProductCardImpression({ productCardRef, shouldSendPrice: false })

	const [firstImage] = useSortedProductImages()

	return (
		<div ref={productCardRef} className={className} data-testid={dataTestId}>
			<SingleProductImage image={firstImage} />
		</div>
	)
}
